export default __webpack_public_path__ + "static/media/vote_proxy_1.63a12946.jpg";